import React from 'react';
import { useCurrentAgreement } from '@economic/react-app';

const LegacyHeader = React.lazy(() => import(/* webpackChunkName: "LegacyHeader" */ './Header'));
const TacoLayoutHeader = React.lazy(() => import(/* webpackChunkName: "TacoLayoutHeader" */ './TacoLayoutHeader'));

export default function Header() {
    const agreement = useCurrentAgreement();
    const hasResponsiveLayout = agreement.features.responsiveLayout;

    return <React.Suspense fallback={<></>}>{hasResponsiveLayout ? <TacoLayoutHeader /> : <LegacyHeader />}</React.Suspense>;
}
